import { useEffect, useState } from "react";
import {
  formatMonthDate,
  formatNumberWithCommas,
  getStartEndOfAnyMonth,
  getStartEndOfCurrentMonth,
} from "../../helper";
import icons from "../../ultils/icons";
import { useAccountStore, useRevenueOverall } from "../../store";
import toast from "react-hot-toast";
import { Dropdown, Select } from "antd";
import { BiSolidError } from "react-icons/bi";
import { useGetTotalErrorAndTestApi } from "../../hooks/record-transaction/useGetTotalErrorAndTestApi";
import { MdHideImage } from "react-icons/md";
import LoadingItem from "../common/LoadingItem";
import api from "../../config/client.axios.api";
import { ROLE } from "../../ultils/constants";
import { ScheduleOutlined } from "@ant-design/icons";
import { RangeCalendar } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";

const listMonth = [
  { value: 1, label: "January (1)" },
  { value: 2, label: "February (2)" },
  { value: 3, label: "March (3)" },
  { value: 4, label: "April (4)" },
  { value: 5, label: "May (5)" },
  { value: 6, label: "June (6)" },
  { value: 7, label: "July (7)" },
  { value: 8, label: "August (8)" },
  { value: 9, label: "September (9)" },
  { value: 10, label: "October (10)" },
  { value: 11, label: "November (11)" },
  { value: 12, label: "December (12)" },
];

const SumStatistical = () => {
  // state
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { FcMoneyTransfer, FcPanorama, FcRatings } = icons;

  const { end, start } = getStartEndOfCurrentMonth();

  const navigate = useNavigate();

  const { info } = useAccountStore();

  const currentDate = new Date();
  const monthCurrent = currentDate.getMonth() + 1;
  const yearCurrent = currentDate.getFullYear();

  const { totalErrorAndTest, isLoading: isLoadingTestOrError } =
    useGetTotalErrorAndTestApi();

  const {
    setEndDate,
    setStartDate,
    setSumOverall,
    sumOverall,
    setYearSelect,
    setMonthSelect,
    monthSelect,
    endDate,
    startDate,
  } = useRevenueOverall();

  const { end: endDayOfMonth, start: startDayOfMonth } = getStartEndOfAnyMonth(
    yearCurrent,
    monthSelect ?? monthCurrent
  );

  useEffect(() => {
    setStartDate(startDayOfMonth);
    setEndDate(endDayOfMonth);
    // if (info?.role === "ROLE_ADMIN") {
    //   setAccountId(undefined);
    // } else {
    //   setAccountId(info?.id);
    // }
    setYearSelect(yearCurrent);
    setMonthSelect(monthSelect ? monthSelect : monthCurrent);
  }, [
    start,
    end,
    info?.id,
    yearCurrent,
    monthCurrent,
    startDayOfMonth,
    endDayOfMonth,
  ]);

  useEffect(() => {
    if (startDate && endDate && info) {
      (async () => {
        setIsLoading(true);
        let result;
        if (info?.role === ROLE.ROLE_STAFF) {
          result = await api.get(`/history/get-revenue-overall`, {
            params: {
              accountId: info?.id,
              startDate,
              endDate,
            },
          });
        } else if (info?.role === ROLE.ROLE_ADMIN) {
          result = await api.get(`/history/get-revenue-overall`, {
            params: {
              startDate,
              endDate,
            },
          });
        }
        setIsLoading(false);
        if (result?.data?.code === 400 || result?.data?.code === 403) {
          toast.error("Get revenue for overall failure !");
        } else {
          setSumOverall(result?.data?.data);
        }
      })();
    }
  }, [startDate, endDate, info?.role]);

  return (
    <>
      <div className="flex w-[100%] flex-col gap-4 h-[100%]">
        <div className="flex justify-between items-center">
          {/* <div>
            <Select
              defaultValue={monthSelect ? monthSelect : monthCurrent}
              style={{ width: 140 }}
              allowClear
              onChange={(e) => {
                setMonthSelect(e);
                if (reload) {
                  setReload(false);
                } else {
                  setReload(true);
                }
              }}
              options={listMonth}
              placeholder="select it"
            />
          </div> */}
          <Dropdown
            overlay={
              <RangeCalendar
                onChange={(value) => {
                  setStartDate(
                    `${value.start.year}-${
                      value.start.month < 10
                        ? `0${value.start.month}`
                        : value.start.month
                    }-${
                      value.start.day < 10
                        ? `0${value.start.day}`
                        : value.start.day
                    }`
                  );

                  setEndDate(
                    `${value.end.year}-${
                      value.end.month < 10
                        ? `0${value.end.month}`
                        : value.end.month
                    }-${
                      value.end.day < 10 ? `0${value.end.day}` : value.end.day
                    }`
                  );

                  setTimeout(() => {
                    setIsDropdownOpen(false);
                  }, 500);
                }}
                aria-label="Date (No Selection)"
              />
            }
            trigger={["click"]}
            open={isDropdownOpen}
            onOpenChange={(flag) => setIsDropdownOpen(flag)}
          >
            <div
              // onClick={() => setIsShowCalender(!isShowCalender)}
              className="flex max-sm:text-[12px] text-sm text-gray-400 gap-2 my-4 cursor-pointer justify-between lg:px-4 px-2 py-1 border-[1px] h-[5vh] items-center border-gray-300 rounded-full bg-white"
            >
              <span className="text-sm placeholder:text-sm">
                {startDate && endDate
                  ? `from ${formatMonthDate(startDate)} to ${formatMonthDate(
                      endDate
                    )}`
                  : "Filter date"}
              </span>
              <ScheduleOutlined />
            </div>
          </Dropdown>
        </div>
        {/* Mobile - Sum Statistical */}
        <div className="flex w-full gap-4 flex-col justify-center items-center">
          {/* Ở trên */}
          <div className="flex max-lg:flex-col justify-center w-full">
            <div className="lg:grid w-[100%] lg:grid-cols-3 max-lg:flex max-lg:flex-col gap-4 h-[100%] justify-between items-center">
              {/* total Revenue */}
              <div
                onClick={() => {
                  navigate("/revenue-store");
                }}
                className="bg-white cursor-pointer hover:bg-gray-100 max-lg:w-full flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg"
              >
                {isLoading ? (
                  <LoadingItem
                    isLoading={isLoading}
                    title={"Loading"}
                  ></LoadingItem>
                ) : (
                  <>
                    <FcRatings className="md:text-[40px] text-[32px]"></FcRatings>
                    <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                      {sumOverall && sumOverall?.totalRevenue
                        ? formatNumberWithCommas(sumOverall?.totalRevenue)
                        : 0}
                    </p>
                    <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                      Total Revenue
                    </span>
                  </>
                )}
              </div>
              {/* total Income */}
              <div
                onClick={() => {
                  navigate("/revenue-store");
                }}
                className="bg-white cursor-pointer hover:bg-gray-100 max-lg:hidden max-lg:w-full flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg"
              >
                {isLoading ? (
                  <LoadingItem
                    isLoading={isLoading}
                    title={"Loading"}
                  ></LoadingItem>
                ) : (
                  <>
                    <FcMoneyTransfer className="md:text-[40px] text-[24px]"></FcMoneyTransfer>
                    <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                      {sumOverall &&
                        sumOverall?.totalIncome &&
                        formatNumberWithCommas(sumOverall?.totalIncome)}
                    </p>
                    <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                      Total Income
                    </span>
                  </>
                )}
              </div>
              {/* total coupon */}
              <div
                onClick={() => {
                  navigate("/revenue-store");
                }}
                className="bg-white cursor-pointer hover:bg-gray-100 max-lg:hidden max-lg:w-full flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg"
              >
                {isLoading ? (
                  <LoadingItem
                    isLoading={isLoading}
                    title={"Loading"}
                  ></LoadingItem>
                ) : (
                  <>
                    <FcPanorama className="md:text-[40px] text-[24px]"></FcPanorama>{" "}
                    <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                      {sumOverall && sumOverall?.totalCoupon}
                    </p>
                    <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                      Total Coupon
                    </span>
                  </>
                )}
              </div>
              {/* Mobile */}
              <div className="max-lg:grid max-lg:grid-cols-2 max-lg:gap-4 max-lg:w-full lg:hidden">
                {/* total Income */}
                <div className="bg-white max-lg:w-full flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg">
                  {isLoading ? (
                    <LoadingItem
                      isLoading={isLoading}
                      title={"Loading"}
                    ></LoadingItem>
                  ) : (
                    <>
                      <FcMoneyTransfer className="md:text-[40px] text-[24px]"></FcMoneyTransfer>
                      <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                        {sumOverall &&
                          sumOverall?.totalIncome &&
                          formatNumberWithCommas(sumOverall?.totalIncome)}
                      </p>
                      <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                        Total Income
                      </span>
                    </>
                  )}
                </div>
                {/* total coupon */}
                <div className="bg-white max-lg:w-full flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg">
                  {isLoading ? (
                    <LoadingItem
                      isLoading={isLoading}
                      title={"Loading"}
                    ></LoadingItem>
                  ) : (
                    <>
                      <FcPanorama className="md:text-[40px] text-[24px]"></FcPanorama>{" "}
                      <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                        {sumOverall && sumOverall?.totalCoupon}
                      </p>
                      <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                        Total Coupon
                      </span>
                    </>
                  )}
                </div>
              </div>
              {/* total test */}
              {/* <div className="bg-white flex max-lg:hidden min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg">
                {isLoadingTestOrError ? (
                  <LoadingItem
                    isLoading={isLoadingTestOrError}
                    title={"Loading"}
                  ></LoadingItem>
                ) : (
                  <>
                    <MdHideImage className="md:text-[40px] text-[24px] text-gray-500" />
                    <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                      {totalErrorAndTest && totalErrorAndTest?.total_test}
                    </p>
                    <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                      Total Test
                    </span>
                  </>
                )}
              </div> */}
              {/* total Error */}
              {/* <div className="bg-white max-lg:hidden flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg">
                {isLoadingTestOrError ? (
                  <LoadingItem
                    isLoading={isLoadingTestOrError}
                    title={"Loading"}
                  ></LoadingItem>
                ) : (
                  <>
                    <BiSolidError className="md:text-[40px] text-[24px] text-red-500" />
                    <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                      {totalErrorAndTest && totalErrorAndTest?.total_error}
                    </p>
                    <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                      Total Error
                    </span>
                  </>
                )}
              </div> */}
              {/* Mobile */}
              <div className="max-lg:grid max-lg:grid-cols-2 max-lg:gap-4 max-lg:w-full lg:hidden">
                {/* total test */}
                {/* <div className="bg-white flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg">
                  {isLoadingTestOrError ? (
                    <LoadingItem
                      isLoading={isLoadingTestOrError}
                      title={"Loading..."}
                    ></LoadingItem>
                  ) : (
                    <>
                      <MdHideImage className="md:text-[40px] text-[24px] text-gray-500" />
                      <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                        {totalErrorAndTest && totalErrorAndTest?.total_test}
                      </p>
                      <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                        Total Test
                      </span>
                    </>
                  )}
                </div> */}
                {/* total error */}
                {/* <div className="bg-white flex min-h-28 lg:min-h-36 flex-col md:py-0 py-4 justify-center items-center shadow-lg rounded-lg">
                  {isLoadingTestOrError ? (
                    <LoadingItem
                      isLoading={isLoadingTestOrError}
                      title={"Loading..."}
                    ></LoadingItem>
                  ) : (
                    <>
                      <BiSolidError className="md:text-[40px] text-[24px] text-red-500" />
                      <p className="font-bold tracking-widest xl:text-xl text-base text-pink-500">
                        {totalErrorAndTest && totalErrorAndTest?.total_error}
                      </p>
                      <span className="text-gray-800 font-semibold flex text-center items-center gap-1 tracking-wide text-base uppercase">
                        Total Error
                      </span>
                    </>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SumStatistical;
